import { createChannelManagementInstance } from '../api-instance';

export interface TWhatsappPasskeyChallenge {
  status: 'pending' | 'none';
  requestOptions?: string;
  createdAt?: string;
}

export interface TWhatsappPasskeyAssertion {
  id?: string;
  rawId?: string;
  type?: string;
  response: {
    clientDataJSON: string;
    authenticatorData: string;
    signature: string;
    userHandle?: string | null;
  };
}

export const getWhatsappPasskeyChallenge = (
  channelId: string
): Promise<TWhatsappPasskeyChallenge> =>
  createChannelManagementInstance<TWhatsappPasskeyChallenge>({
    url: `/api/v1/channels/${encodeURIComponent(channelId)}/whatsapp/passkey/challenge`,
    method: 'GET',
  });

export const submitWhatsappPasskeyAssertion = (
  channelId: string,
  assertion: TWhatsappPasskeyAssertion
): Promise<void> =>
  createChannelManagementInstance<void>({
    url: `/api/v1/channels/${encodeURIComponent(channelId)}/whatsapp/passkey/assertion`,
    method: 'POST',
    data: assertion,
  });
